export const GET_STAFF_TYPES = "GET_STAFF_TYPES"
export const GET_STAFF_TYPES_SUCCESS = "GET_STAFF_TYPES_SUCCESS"
export const GET_STAFF_TYPES_FAILED = "GET_STAFF_TYPES_FAILED"

export const GET_STAFF_BY_STAFFTYPE = "GET_STAFF_BY_STAFFTYPE"
export const GET_STAFF_BY_STAFFTYPE_SUCCESS = "GET_STAFF_BY_STAFFTYPE_SUCCESS"
export const GET_STAFF_BY_STAFFTYPE_FAILED = "GET_STAFF_BY_STAFFTYPE_FAILED"

export const CREATE_GATEPASS_APPROVER = "CREATE_GATEPASS_APPROVER"
export const CREATE_GATEPASS_APPROVER_SUCCESS = "CREATE_GATEPASS_APPROVER_SUCCESS"
export const CREATE_GATEPASS_APPROVER_FAILED = "CREATE_GATEPASS_APPROVER_FAILED"


export const GET_ALL_APPROVAL_STAFF = "GET_ALL_APPROVAL_STAFF"
export const GET_ALL_APPROVAL_STAFF_SUCCESS = "GET_ALL_APPROVAL_STAFF_SUCCESS"
export const GET_ALL_APPROVAL_STAFF_FAILED = "GET_ALL_APPROVAL_STAFF_FAILED"

export const GET_ALL_GATEPASS_REQUEST = "GET_ALL_GATEPASS_REQUEST"
export const GET_ALL_GATEPASS_REQUEST_SUCCESS = "GET_ALL_GATEPASS_REQUEST_SUCCESS"
export const GET_ALL_GATEPASS_REQUEST_FAILED = "GET_ALL_GATEPASS_REQUEST_FAILED"

export const UPDATE_GATEPASS_REQUEST = "UPDATE_GATEPASS_REQUEST";
export const UPDATE_GATEPASS_REQUEST_SUCCESS = "UPDATE_GATEPASS_REQUEST_SUCCESS";
export const UPDATE_GATEPASS_REQUEST_FAILED = "UPDATE_GATEPASS_REQUEST_FAILED";



export const UPDATE_ADMIN_GATEPASS_REQUEST = "UPDATE_ADMIN_GATEPASS_REQUEST";
export const UPDATE_ADMIN_GATEPASS_REQUEST_SUCCESS = "UPDATE_ADMIN_GATEPASS_REQUEST_SUCCESS";
export const UPDATE_ADMIN_GATEPASS_REQUEST_FAILED = "UPDATE_ADMIN_GATEPASS_REQUEST_FAILED";

export const GET_TEACHER_GATEPASS_REPORT = "GET_TEACHER_GATEPASS_REPORT"
export const GET_TEACHER_GATEPASS_REPORT_SUCCESS = "GET_TEACHER_GATEPASS_REPORT_SUCCESS"
export const GET_TEACHER_GATEPASS_REPORT_FAILED = "GET_TEACHER_GATEPASS_REPORT_FAILED"


export const CREATE_GATEPASS_APPROVAL = "CREATE_GATEPASS_APPROVAL"
export const CREATE_GATEPASS_APPROVAL_SUCCESS = "CREATE_GATEPASS_APPROVAL_SUCCESS"
export const CREATE_GATEPASS_APPROVAL_FAILED = "CREATE_GATEPASS_APPROVAL_FAILED"


export const GET_GATEPASS_REPORT = "GET_GATEPASS_REPORT"
export const GET_GATEPASS_REPORT_SUCCESS = "GET_GATEPASS_REPORT_SUCCESS"
export const GET_GATEPASS_REPORT_FAILED = "GET_GATEPASS_REPORT_FAILED"

export const GET_ALL_STAFF = "GET_ALL_STAFF"
export const GET_ALL_STAFF_SUCCESS = "GET_ALL_STAFF_SUCCESS"
export const GET_ALL_STAFF_FAILED = "GET_ALL_STAFF_FAILED"